<template>
    <el-select
      v-model="hubTypeSelected"
      @change="handleChange"
      :placeholder="$t('customerCenter.appointments.placeholder.hub')"
      :disabled="disabled"
  >
      <el-option
          v-for="option in hubType"
          :key="option.value"
          :label="option.label"
          :value="option.label"
      />
  </el-select>
</template>
<script>
import constants from '@/utils/constants';

export default {
  name: 'HubSelect',
  computed: {
    hubType() {
      if (this.empty) {
        return [{ value: null, label: ' ', shortLabel: ' ' }, ...constants.APPOINTMENTS.HUBTYPE];
      }
      return constants.APPOINTMENTS.HUBTYPE;
    },
    hubTypeSelected: {
      get() {
        return this.value; // Obtiene el valor de la prop
      },
      set(newValue) {
        this.$emit('input', newValue); // Emite el nuevo valor al componente padre
      }
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    empty: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    reset() {
      this.hubTypeSelected = null;
      this.$emit('input', null);
      this.$emit('change', null);
    },
    handleChange(value) {
      this.$emit('change', value);
    }
  },

};
</script>
